import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, selectedCategory, onCategoryChange, contentCount }) => {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h3 className="text-lg md:text-xl font-heading font-bold text-foreground">
          Filtrar por Categoria
        </h3>
        <span className="text-sm md:text-base text-muted-foreground">
          {contentCount} {contentCount === 1 ? 'item' : 'itens'}
        </span>
      </div>
      <div className="flex flex-wrap gap-2 md:gap-3">
        <button
          onClick={() => onCategoryChange('all')}
          className={`px-4 py-2 md:px-5 md:py-2.5 rounded-md font-medium text-sm md:text-base transition-smooth ${
            selectedCategory === 'all' ?'bg-primary text-primary-foreground glow-primary' :'bg-card text-foreground hover:bg-muted hover:glow-primary-hover'
          }`}
        >
          <span className="flex items-center gap-2">
            <Icon name="Grid" size={18} />
            Todas
          </span>
        </button>

        {categories?.map((category) => (
          <button
            key={category?.id}
            onClick={() => onCategoryChange(category?.id)}
            className={`px-4 py-2 md:px-5 md:py-2.5 rounded-md font-medium text-sm md:text-base transition-smooth ${
              selectedCategory === category?.id
                ? 'bg-primary text-primary-foreground glow-primary'
                : 'bg-card text-foreground hover:bg-muted hover:glow-primary-hover'
            }`}
          >
            <span className="flex items-center gap-2">
              <Icon name={category?.icon} size={18} />
              {category?.name}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;